"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGatesMap = getGatesMap;
exports.getUngatedGates = getUngatedGates;

var _underscore = require("underscore");

/**
 * Gets a gates map
 *
 * Each key identifies the gate, and its value is true if the gate is
 * ungated, otherwise false.
 *
 * @param {string[]} gates The gates which are ungated
 * @param {string[]} gatesToCheck All of the gates to check. Each of these will be present as a key in the returned gates map
 * @returns {object} The gates map
 */
function getGatesMap(gates, gatesToCheck) {
  var ungatedGates = (0, _underscore.intersection)(gatesToCheck, gates);
  return (0, _underscore.object)(gatesToCheck.map(function (gateName) {
    return [gateName, (0, _underscore.contains)(ungatedGates, gateName)];
  }));
}
/**
 * Gets an array containing all enabled gates
 *
 * @param {Object} gates The gates map, where each key is a gate and its value is true if it is ungated
 * @returns {string[]} An array containing only the ungated gates
 */


function getUngatedGates(gates) {
  return Object.keys(gates).filter(function (gate) {
    return gates[gate];
  });
}